export default "__VITE_ASSET__BPVFR_sb__"